import { createContext, useContext } from 'react';

export const HighlightTabDropdownContext = createContext({ indexOffset: 0 });

export const useHighlightTabDropdownContext = () => useContext(HighlightTabDropdownContext);

export const HighlightTabOptionContext = createContext({ index: 0 });

export const useHighlightTabOptionContext = () => useContext(HighlightTabOptionContext);
